import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DropdownModule } from 'primeng/dropdown';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';
import { ProductFormComponent } from './product-form.component';
import { ProductVariantFormComponent } from './product-variant-form/product-variant-form.component';
@NgModule({
  declarations: [ProductFormComponent, ProductVariantFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputTextModule,
    DropdownModule,
    InputMaskModule,
    ButtonModule,
    CheckboxModule,
    FileUploadModule,
    ToastModule,
    InputTextareaModule,
    EditorModule,
    InputNumberModule,
    FieldsetModule,
    TooltipModule,
    ConfirmDialogModule,
    AutoCompleteModule
  ],
  exports: [ProductFormComponent, ProductVariantFormComponent]
})
export class ProductFormModule {}
